module.exports = __webpack_public_path__ + "static/media/1 25 dysleksi.21e20dcb.mp3";